import AssetPackAssetsEditor from './AssetsEditor'

export default AssetPackAssetsEditor
